import { Row, Col, Card, CardBody } from "reactstrap";
import { WORK_EXPERIENCE_FIELDS } from "./CONSTANT";
import { FieldInput } from "../../../components/FieldInput";

export default function WorkExperienceForm({ validation }) {
  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {WORK_EXPERIENCE_FIELDS.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
